import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { ApiServicesService } from 'src/app/services/apiServices/api-services.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { LocalStorageProvider } from 'src/app/services/storage/storage.service';
import { MatSelect } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-patner-with-us',
  templateUrl: './patner-with-us.component.html',
  styleUrls: ['./patner-with-us.component.scss'],
  encapsulation: ViewEncapsulation.None 
})
export class PatnerWithUsComponent implements OnInit {
  addForm: any;
  subcategory: any;
  subCategory: any = [];
  filteredStateData: any;
  filteredcityData: any;
  constructor(private service: ApiServicesService, private storageService: LocalStorageProvider, private commonService: CommonService, private fb: FormBuilder,private toastr: ToastrService,private route: ActivatedRoute,) {
    window.scrollTo(0, 0);  
  }
  ngOnInit(): void {
    window.scrollTo(0, 0);  
    this.getState();
    this.cityData = [{id:'0',city:'No Data Availabe'}]; 
    this.addForm = this.fb.group({
      utm_source: ['',],
      utm_medium: ['',],
      utm_campaign: ['',],
      utm_term: ['',],
      utm_content: ['',],
      utm_placement: ['',], 
      person_name: ['', [Validators.required]],
      designation: ['', [Validators.required]],
      company_name: ['', [Validators.required]],
      email: ['', [Validators.required,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')]],
      mobile_number: ['', [Validators.required, Validators.minLength(10),Validators.pattern('^[0-9]*$')]],
      website_url: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      country_code: ['+91', []],
      description: ['', []]
    })

    this.route.queryParams.subscribe(params => {     
      if (!params || typeof params !== 'object') return;
      const utmsourceValue =  params['utm_source'] || ''; 
      const utmMediumValue =  params['utm_medium'] || ''; 
      const utmCampaignValue =  params['utm_campaign'] || ''; 
      const utmtermValue =  params['utm_term'] || ''; 
      const utmcontentValue =  params['utm_content'] || ''; 
      const utmplacementValue =  params['utm_placement'] || ''; 
      this.addForm.patchValue({ 
        utm_source: utmsourceValue,
        utm_medium: utmMediumValue,
        utm_campaign: utmCampaignValue,
        utm_term: utmtermValue,
        utm_content: utmcontentValue, 
        utm_placement: utmplacementValue 
      });

    });

  }

  searchValue: string = '';
  filterStates(searchValue: string) {
    const search = searchValue.toLowerCase();
    this.filteredStateData = this.stateData.filter((state: { name: string; }) =>
      state.name.toLowerCase().includes(search)
    );
  }
  filterCity(searchValue: string) {
    const search = searchValue.toLowerCase();
    this.filteredcityData = this.cityData.filter((city: { city: string; }) =>
      city.city.toLowerCase().includes(search)
    );
  }
  onCityChange(event: any) {
    this.clearSearch();
  }
  clearSearch(searchInput?: HTMLInputElement) {
    if (searchInput) {
      searchInput.value = '';
    }
    this.filteredStateData = [...this.stateData]; 
  }
  clearSearch1(searchInput1?: HTMLInputElement) {
    if (searchInput1) {
      searchInput1.value = '';
    }
    this.filteredcityData = [...this.cityData];
  }
  submitted = false;
  onSubmit(post: any) {
    this.submitted = true;
    const profileData = this.addForm.value;

    if (!profileData.description || (typeof profileData.description === 'string' && profileData.description.trim() === '')) { 
      profileData.description = ''; 
    
    }
    if (this.addForm.valid) {
      this.service.post(post, `${API_ROUTES.Account.addPartner}`, {}).pipe().subscribe((res) => {
        if (res.success == true) {
            this.toastr.success('Form submitted successfully');
            window.scrollTo(0, 0);
            const countryCode = this.addForm.get('country_code').value;
            this.submitted = false; 
          this.addForm.reset();
          this.addForm.get('country_code').setValue(countryCode);
        } else {
          console.log(res.message);
        }
      },
        (error) => {
          console.log(error.message);
        });
    } else {
      console.log('error in submitting');
    }
  }
  
  stateData: any;
  cityData: any;
  getState() {
    this.service.get({}, API_ROUTES.Account.stateCity).subscribe(
      (res) => {
        if (res.success && res.data) {
          this.stateData = res.data?.filter((state:any) => state.id !== 37);
          this.filteredStateData = [...this.stateData];

        }
      },
      (error) => {
        console.error('API call failed:', error);
      }
    );
  }

  onStateChange(event: any) {
    const stateId = event.value;
    if (stateId) {
      this.getCityData(stateId);  
    }
  }

  getCityData(stateId: string) {
    this.service.get({ stateId }, API_ROUTES.Account.stateCity).subscribe(
      (res) => {
        if (res.success && res.data) {
          this.cityData = res.data;  
          this.filteredcityData = [...this.cityData]
        } else {
          this.cityData = [];  // Clear city data if no cities found
        }
      },
      (error) => {
        console.error('API call failed for cities:', error);
      }
    );
  }


  staticlocation = [
    { id: 1, title: 'New Delhi' },
    { id: 2, title: 'Himachal Pradesh' },
    { id: 3, title: 'Punjab' }
  ];
  filteredCat = this.staticlocation;



  // createForm(){

  // }
  // get f() { return this.patnerwithusForm.controls; }
}
